import React from 'react';
import { translate } from '../Services/translation';
import { useSelector, useDispatch } from 'react-redux';

const MiniCart = () => {
    const dispatch = useDispatch();
    const { quantity, checkoutUrl } = useSelector(
        (state) => state.cart
    );

    return (
        <div className="checkout cart cart--mini">
            <a
                className="cart__link--block"
                rel="nofollow"
                href={checkoutUrl}
            >
                {quantity > 0 ?                 
                    <span className="cart__quantity">{quantity}</span>
                    : ""
                }
                <span className="">
                    {translate('coptikk.cart')}
                </span>
            </a>
        </div>
    );
};

export default MiniCart;
